// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hero[data-v-50faae70]{position:relative}.hero-btns[data-v-50faae70]{position:absolute;left:48%;bottom:15%}", ""]);
// Exports
module.exports = exports;
